export const LoadingCards = () => {
    return (
        <>
            {/* <div className="flex justify-between mb-4">
                <div className="w-full">
                    <div className="h-[24px] w-3/6 bg-elitLightGrey/30 animate-pulse rounded mb-1"></div>
                    <div className="h-[20px] w-1/5 bg-elitLightGrey/30 animate-pulse rounded-full mb-1"></div>
                </div>
                <div className="min-h-8 h-8 min-w-8 w-8 bg-elitLightGrey/30 rounded-full"></div>
            </div> */}

            <div className="flex flex-col gap-2">
                {[0, 1, 2, 3, 4].map((i) => {
                    return (
                        <div
                            key={`loading-task-${i}`}
                            className="bg-elitStrokeGrey p-4 pb-3 rounded-[20px] border-elitStrokeGrey border-solid"
                        >
                            <div className="bg-elitLightGrey/30 h-[36px] w-full rounded-lg mb-2"></div>
                            <div className="flex justify-between">
                                <div>
                                    <div className="bg-elitLightGrey/30 h-[20px] w-36 rounded my-3"></div>
                                    <div className="bg-elitLightGrey/30 h-4 w-24 rounded mb-1"></div>
                                </div>
                                <div>
                                    <div className="min-h-8 h-8 min-w-8 w-8 bg-elitLightGrey/30 rounded-full"></div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};
